<template>
  <div>
    <loading :active="loading"></loading>
    <main-layout :active="10">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title mb-0">🤝 Parcerias e Influenciadores</h4>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>DATA</th>
                    <th>NOME</th>
                    <th>CONTATO</th>
                    <th>REDES SOCIAIS</th>
                    <th>STATUS</th>
                    <th>AÇÕES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="applications.length <= 0">
                    <td colspan="6" class="text-center py-4">
                      <span style="color: #9CA3AF;">Nenhuma aplicação encontrada</span>
                    </td>
                  </tr>
                  <tr v-for="item in applications" :key="item.id">
                    <td>{{ formatDate(item.createdAt) }}</td>
                    <td>
                      <strong>{{ item.name }}</strong><br>
                      <small class="text-muted">{{ item.email }}</small>
                    </td>
                    <td>
                      <a :href="'https://wa.me/55' + item.whatsapp.replace(/\D/g, '')" target="_blank"
                        class="btn btn-outline-success btn-xs">
                        📱 {{ item.whatsapp }}
                      </a>
                    </td>
                    <td>
                      <div class="d-flex flex-wrap gap-1">
                        <span v-if="item.instagram_handle" class="badge bg-light text-dark">
                          📸 {{ item.instagram_handle }}
                        </span>
                        <span v-if="item.tiktok_handle" class="badge bg-light text-dark">
                          🎵 {{ item.tiktok_handle }}
                        </span>
                        <span v-if="item.youtube_channel" class="badge bg-light text-dark">
                          📺 YouTube
                        </span>
                      </div>
                      <small class="text-muted">{{ item.platforms }}</small>
                    </td>
                    <td>
                      <span :class="getStatusClass(item.status)">{{ getStatusText(item.status) }}</span>
                    </td>
                    <td>
                      <button class="btn btn-primary btn-sm" @click="viewDetails(item)">
                        Ver Detalhes
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de Detalhes -->
      <div v-if="selectedApp" class="modal-overlay" @click.self="selectedApp = null">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Detalhes da Aplicação</h5>
            <button type="button" class="btn-close" @click="selectedApp = null"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <strong>Motivo da Parceria:</strong>
              <p class="mt-2 text-muted"
                style="white-space: pre-wrap; background: #f8fafc; padding: 15px; border-radius: 8px;">
                {{ selectedApp.reason }}
              </p>
            </div>

            <div class="mb-3">
              <strong>Status Atual:</strong>
              <select class="form-control mt-2" v-model="selectedApp.status" @change="updateStatus(selectedApp)">
                <option value="pending">Pendente</option>
                <option value="approved">Aprovado</option>
                <option value="rejected">Rejeitado</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="selectedApp = null">Fechar</button>
          </div>
        </div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from "../../components/Layouts/MainLayout.vue";
import api from "../../services/funcoes-service";
import moment from "moment";
import Loading from "../../components/Layouts/Loading.vue";

export default {
  components: { MainLayout, Loading },
  data() {
    return {
      applications: [],
      loading: true,
      selectedApp: null
    };
  },
  async mounted() {
    await this.getApplications();
  },
  methods: {
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    getStatusClass(status) {
      const classes = {
        pending: "badge bg-warning text-dark",
        approved: "badge bg-success",
        rejected: "badge bg-danger"
      };
      return classes[status] || "badge bg-secondary";
    },
    getStatusText(status) {
      const texts = {
        pending: "Pendente",
        approved: "Aprovado",
        rejected: "Rejeitado"
      };
      return texts[status] || status;
    },
    async getApplications() {
      try {
        this.loading = true;
        const response = await api.get("/influencers/applications");
        if (response.data.error === 0) {
          this.applications = response.data.applications;
        }
      } catch (error) {
        console.error("Erro ao carregar aplicações:", error);
      } finally {
        this.loading = false;
      }
    },
    viewDetails(app) {
      this.selectedApp = { ...app };
    },
    async updateStatus(app) {
      try {
        this.loading = true;
        const response = await api.put(`/influencers/applications/${app.id}/status`, {
          status: app.status
        });
        if (response.data.error === 0) {
          this.$toast.success("Status atualizado com sucesso");
          await this.getApplications();
        }
      } catch (error) {
        this.$toast.error("Erro ao atualizar status");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 0;
  border-radius: 12px;
  max-width: 600px;
  width: 90%;
  overflow: hidden;
}

.modal-header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  text-align: right;
}

.btn-xs {
  padding: 2px 8px;
  font-size: 11px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
</style>
